import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      width: '80px',
      height: '80px',
      position: 'relative',
      margin: '0 auto',
      perspective: '1000px',
      perspectiveOrigin: '50% 100%',
    },
    dice: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      transformStyle: 'preserve-3d',
      transition: 'transform 6s',

      '& div': {
        backgroundColor: theme.palette.primary.main,
        display: 'block',
        position: 'absolute',
        width: '80px',
        height: '80px',
        margin: '0 auto',
        fontSize: '500%',
        textAlign: 'center',
      },
    },
    dot: {
      display: 'block',
      position: 'absolute',
      width: '12px',
      height: '12px',
      backgroundColor: theme.palette.secondary.light,
      borderRadius: '6px',
    },
    face1: {
      transform: 'translateZ(40px)',
    },
    face1Dot1: {
      top: '34px',
      left: '34px',
    },
    face2: {
      transform: 'rotateX(-180deg) translateZ(40px)',
    },
    face2Dot1: {
      top: '18px',
      left: '18px',
    },
    face2Dot2: {
      top: '50px',
      left: '50px',
    },
    face3: {
      transform: 'rotateY(90deg) translateZ(40px)',
    },
    face3Dot1: {
      top: '18px',
      left: '18px',
    },
    face3Dot2: {
      top: '34px',
      left: '34px',
    },
    face3Dot3: {
      top: '50px',
      left: '50px',
    },
    face4: {
      transform: 'rotateY(-90deg) translateZ(40px)',
    },
    face4Dot1: {
      top: '18px',
      left: '18px',
    },
    face4Dot2: {
      top: '18px',
      left: '50px',
    },
    face4Dot3: {
      top: '50px',
      left: '18px',
    },
    face4Dot4: {
      top: '50px',
      left: '50px',
    },
    face5: {
      transform: 'rotateX(90deg) translateZ(40px)',
    },
    face5Dot1: {
      top: '18px',
      left: '18px',
    },
    face5Dot2: {
      top: '18px',
      left: '50px',
    },
    face5Dot3: {
      top: '34px',
      left: '34px',
    },
    face5Dot4: {
      top: '50px',
      left: '18px',
    },
    face5Dot5: {
      top: '50px',
      left: '50px',
    },
    face6: {
      transform: 'rotateX(-90deg) translateZ(40px)',
    },
    face6Dot1: {
      top: '18px',
      left: '18px',
    },
    face6Dot2: {
      top: '34px',
      left: '18px',
    },
    face6Dot3: {
      top: '50px',
      left: '18px',
    },
    face6Dot4: {
      top: '18px',
      left: '50px',
    },
    face6Dot5: {
      top: '34px',
      left: '50px',
    },
    face6Dot6: {
      top: '50px',
      left: '50px',
    },
  }),
);

export default useStyles;
